var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#222222",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C13.1504 8.02231 11.3829 8.76698 10.0749 10.0749C8.76698 11.3829 8.02231 13.1504 8 15C8.02231 16.8496 8.76698 18.6171 10.0749 19.9251C11.3829 21.233 13.1504 21.9777 15 22C16.8496 21.9777 18.6171 21.233 19.9251 19.9251C21.233 18.6171 21.9777 16.8496 22 15C21.9777 13.1504 21.233 11.3829 19.9251 10.0749C18.6171 8.76698 16.8496 8.02231 15 8ZM19 15.5H15.5V19H14.5V15.5H11V14.5H14.5V11H15.5V14.5H19V15.5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav2);
export default __webpack_public_path__ + "static/media/nav2.3f33dd477930a20c872c61da985c92b5.svg";
export { ForwardRef as ReactComponent };